import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getMetadataCounts } from "../../../Auth/Services/metadataService";
import NormalAlert from "../../../Alerts/NormalAlert";
import { GetEmployeeName } from "../../../Auth/Services/authService";
import Cookies from "js-cookie";

import {
  GitBranch,
  BarChart3,
  MapPin,
  Building2,
  MapPinned,
  IdCard,
  Briefcase,
  Users 
} from "lucide-react";

const MasterData = () => {
  const navigate = useNavigate();

  const [metadataCounts, setMetadataCounts] = useState({
    functionCount: 0,
    gradeCount: 0,
    zoneCount: 0,
    departmentCount: 0,
    jobLocationCount: 0,
    // roleTypeCount: 0,
    jobCategoryCount: 0,
    genderPreferenceCount: 0
  });

  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState(null);

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const result = await getMetadataCounts();
        if (result && result.length > 0) setMetadataCounts(result[0]);
      } catch (error) {
        const safeMessage =
          error?.response?.data?.message ||
          "Something went wrong. Please try again.";

        setAlert({
          type: "fail",
          message: safeMessage,
        });
      } finally {
        setLoading(false);
      }
    };

    fetchCounts();
  }, []);

  useEffect(() => {
    const checkRole = async () => {
      const token = Cookies.get("employeeToken");
      if (!token) {
        navigate("/");
        return;
      }

      try {
        const response = await GetEmployeeName(token);
        const userRole = response?.data?.employeeRole;

        if (userRole !== "Admin Employee") {
          navigate("/Dashboard");
        }
      } catch {
        navigate("/Dashboard");
      }
    };

    checkRole();
  }, []);

  const handleCardClick = (type) => {
    navigate(`/Admin/Master-Data/${type}`);
  };

  const cards = [
    {
      title: "Functions",
      type: "Functions",
      count: metadataCounts.functionCount,
      icon: <GitBranch size={38} strokeWidth={2} />,
    },
    {
      title: "Departments",
      type: "Departments",
      count: metadataCounts.departmentCount,
      icon: <Building2 size={38} strokeWidth={2} />,
    },
    {
      title: "Grades",
      type: "Grades",
      count: metadataCounts.gradeCount,
      icon: <BarChart3 size={38} strokeWidth={2} />,
    },
    {
      title: "Zones",
      type: "Zones",
      count: metadataCounts.zoneCount,
      icon: <MapPin size={38} strokeWidth={2} />,
    },
    {
      title: "Job Locations",
      type: "Job-Locations",
      count: metadataCounts.jobLocationCount,
      icon: <MapPinned size={38} strokeWidth={2} />,
    },
    {
      title: "Job Categories",
      type: "Job-Category",
      count: metadataCounts.jobCategoryCount,
      icon: <Briefcase size={38} strokeWidth={2} />,
    },
    {
      title: "Gender Preference",
      type: "Gender-Preference",
      count: metadataCounts.genderPreferenceCount,
      icon: <Users  size={38} strokeWidth={2} />,
    },
  ];

  return (
    <>
      <div className="min-h-screen">
        <div className="max-w-[1200px] mx-auto pt-20 pb-16 px-6">
          <h2 className="text-3xl font-bold text-center text-[#1e76fb] mb-14">
            Master Data Overview
          </h2>

          {loading ? (
            <div className="flex justify-center mt-10">
              <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-[#1e76fb]" />
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
              {cards.map((card, index) => (
                <div
                  key={index}
                  onClick={() => handleCardClick(card.type)}
                  className="bg-white rounded-2xl shadow-sm hover:shadow-md p-7 text-center cursor-pointer transition duration-300 hover:-translate-y-1"
                >
                  <div className="flex justify-center text-[#1e76fb] mb-6">
                    {card.icon}
                  </div>

                  <h4 className="text-lg font-semibold text-gray-700">
                    {card.title}
                  </h4>

                  <p className="text-2xl font-bold mt-4 text-gray-900">
                    {card.count}
                  </p>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {alert && (
        <NormalAlert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert(null)}
        />
      )}
    </>
  );
};

export default MasterData;
